"use client";

import PageContent from "@/components/page-content";
import SectionHeader from "@/components/landing/section-header";
import { Globe2 } from "lucide-react";
import { Demos } from './demos';

export function RealWorldDemos() {
  return (
    <PageContent>
      <SectionHeader
        sectionIcon={<Globe2 className="size-4" />}
        section="Real-world demos"
        heading="Built for production use cases"
        description="Same API, endless applications. See Image Captioning across different domains."
        className="pb-4"
      />
      <div className="flex flex-col gap-4">
        <Demos />
      </div>
    </PageContent >
  );
}

